import API from '@/api/user'
import Vue from 'vue'

function defaultState() {
  return {
    user: {},
    deviceRequests: []
  };
}
const state = defaultState();

const actions = {

  // CUONA購入申請をマネージャーからオーナーへ送る
  createDeviceRequest ({commit}, payload) {
    return API.createDeviceRequest(payload)
      .then(function(response) {
        commit('setDeviceRequests', response)
      })
  },

  // CUONA購入申請を削除
  deleteDeviceRequest ({commit}, id) {
    return API.deleteDeviceRequest(id)
      .then(function(response) {
        commit('setDeviceRequests', response)
      })
  },

  // ストライプでの支払いを作成
  createCharges ({commit}, params) {
    return API.createCharges(params)
      .then(function(response) {
        commit('setStripeCustomerId', response.stripe_customer_id)
      })
  },

  signOutReset({commit}) {
    commit('_reset');
  }
}

const mutations = {

  // ユーザー情報をセット
  setUser (state, user) {
    state.user = user
  },

  // CUONA購入申請一覧をセット
  setDeviceRequests (state, deviceRequests) {
    state.deviceRequests = deviceRequests
  },

  // ストライプのcustomer_idをセット
  setStripeCustomerId (state, stripe_customer_id) {
    state.user.stripe_customer_id = stripe_customer_id
  },

  _reset(state) {
    const initialState = defaultState();
    for (const key in state) {
      if (state.hasOwnProperty(key)) {
        state[key] = initialState[key];
      }
    }
  }
}

const getters = {

  company: state => {
    return state.user.company
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
